import Divider from './divider.element.js';

export default Divider;

Divider.define('wje-divider', Divider);
